import { IIrrigationArea } from "@/utils/interfaces";
import * as turf from "@turf/turf";
import { IRRIGATION_AREA_LINEAR_PECISION } from "./constants";

export function getIrrigationArea(feature: turf.AllGeoJSON): IIrrigationArea {
    const [point3, point2, point1] = (feature as any).geometry.coordinates[0].slice(- 3)
    const lineString1 = turf.lineString([point1, point2], { name: 'lineString1' })
    const lineString2 = turf.lineString([point2, point3], { name: 'lineString2' })
    const length1 = Number(turf.length(lineString1, { units: 'kilometers' }).toFixed(IRRIGATION_AREA_LINEAR_PECISION))
    const length2 = Number(turf.length(lineString2, { units: 'kilometers' }).toFixed(IRRIGATION_AREA_LINEAR_PECISION))

    const irrigationArea = {
        area: turf.area(feature),
        bearing: [turf.bearing(point1, point2), turf.bearing(point2, point3)],
        feature,
        length: Math.max(length1, length2),
        width: Math.min(length1, length2),
    }
    return irrigationArea;
}
